import React from "react";
import { history } from "../store";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";

import GoogleTranslate from "../components/GoogleTranslate"; // Adjust path if needed
import { fetchMachinesNightscan } from "../actions/machines";
import FloatingToolsButton from '../components/FloatingToolsButton';


import {
  Collapse,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
} from "reactstrap";

import { authLogout } from "../actions/auth";

class AppHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      showNightscanList: false,
      nightscanIssues: [],
      showDragon: false, //TONTUNA
      showFutbol: false, //TONTUNA
      showDuck: false, //TONTUNA
      showCuba: false, //TONTUNA
      showCrocs: false, //TONTUNA
    };

    this.toggle = this.toggle.bind(this);
    this.logout = this.logout.bind(this);
    this.showDragonGif = this.showDragonGif.bind(this);
    this.toggleNightscanList = this.toggleNightscanList.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  logout() {
    this.props.authLogout();
    this.props.push("/login");
  }

  handleNavLinkClick() {
    this.setState({
      isOpen: false,
    });
  }

  goTo(id) {
    window.open(`/machines/${id}`, "_blank");
  }

  formatNightscanDate = (timestamp) => {
    const year = timestamp.substring(0, 4);
    const month = timestamp.substring(4, 6) - 1; // JavaScript months are 0-11
    const day = timestamp.substring(6, 8);
    const hour = timestamp.substring(8, 10);
    const minute = timestamp.substring(10, 12);
    const second = timestamp.substring(12, 14);

    return new Date(year, month, day, hour, minute, second);
  };

  isNightscanInSleepPeriod = (nightscanDate, sleepStart, sleepEnd) => {
    if (
      !nightscanDate ||
      !(nightscanDate instanceof Date) ||
      isNaN(nightscanDate)
    ) {
      return false;
    }

    const now = new Date();
    const today = new Date(now);
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    // Check if nightscanDate is from today or yesterday
    const isTodayOrYesterday =
      nightscanDate.toDateString() === today.toDateString() ||
      nightscanDate.toDateString() === yesterday.toDateString();

    if (!isTodayOrYesterday) return false;

    const startHours = Math.floor(sleepStart / 100);
    const startMinutes = sleepStart % 100;
    const endHours = Math.floor(sleepEnd / 100);
    const endMinutes = sleepEnd % 100;

    let startDate = new Date(nightscanDate);
    startDate.setHours(startHours, startMinutes, 0, 0);

    let endDate = new Date(nightscanDate);
    endDate.setHours(endHours, endMinutes, 0, 0);

    // If sleepStart is greater than sleepEnd, it means the sleep spans across midnight
    if (
      startHours > endHours ||
      (startHours === endHours && startMinutes > endMinutes)
    ) {
      // Adjust the dates to span midnight
      if (nightscanDate.toDateString() === yesterday.toDateString()) {
        // The nightscanDate is from yesterday, so we set the startDate as yesterday's date
        startDate = new Date(yesterday);
        startDate.setHours(startHours, startMinutes, 0, 0);

        // The endDate will be today at the sleepEnd time
        endDate = new Date(today);
        endDate.setHours(endHours, endMinutes, 0, 0);
      } else if (nightscanDate.toDateString() === today.toDateString()) {
        // The nightscanDate is from today, we need to check if it’s within the end range
        const previousDayStartDate = new Date(yesterday);
        previousDayStartDate.setHours(startHours, startMinutes, 0, 0);

        // End date remains as today's sleepEnd
        return (
          nightscanDate >= previousDayStartDate && nightscanDate <= endDate
        );
      }
    }

    // Normal case where sleepStart is less than or equal to sleepEnd (no midnight spanning)
    return nightscanDate >= startDate && nightscanDate <= endDate;
  };

  showDragonGif() {
    const { role, type, fullname, id } = this.props;

    if (fullname === "Daniel Souto") {
      this.setState((prevState) => ({
        showDragon: !prevState.showDragon,
      }));
    } else if (fullname === "Albert Parra") {
      this.setState((prevState) => ({
        showFutbol: !prevState.showFutbol,
      }));
    } else if (fullname === "Berta Manteca") {
      this.setState((prevState) => ({
        showDuck: !prevState.showDuck,
      }));
    } else if (fullname === "Sheyla Pardo") {
      this.setState((prevState) => ({
        showCuba: !prevState.showCuba,
      }));
    } else if (fullname === "Marc Viarnes") {
      this.setState((prevState) => ({
        showCrocs: !prevState.showCrocs,
      }));
    }
  }

  toggleNightscanList() {
    this.setState((prev) => ({
      showNightscanList: !prev.showNightscanList,
    }));
  }

  getMachineStatus(status, signal) {
    if (!status) {
      return "UNKNOWN";
    }

    const now = Date.now();
    const lastSignalTime = Date.parse(signal);
    const diffInSeconds = (now - lastSignalTime) / 1000;

    if (diffInSeconds >= 60 * 5) {
      return "OFFLINE";
    }

    const statusMap = {
      OPERATIVE: "ONLINE",
      SLEEP: "SLEEP",
      NIGHT_SCAN: "NIGHTSCAN",
      MAINTENANCE: "MANTENIMIENTO",
      LOCKERS_FULL: "LOCKERS LLENOS",
      TICKET_EMPTY: "SIN TICKET",
      OPERATIVE_SLEEP: "SLEEP ONLINE",
      MAINTENANCE_SLEEP: "SLEEP MAINTENANCE",
      KERONG_OTA: "OTA KERONG",
      BOOTLOADER_OTA: "OTA BOOTLOADER",
      BLE_OFF: "POWER DOWN",
    };

    return statusMap[status] || "UNKNOWN";
  }

  getMachineStatusColor(status, signal) {
    const now = Date.now();
    const lastSignalTime = Date.parse(signal);
    const diffInSeconds = (now - lastSignalTime) / 1000;

    if (diffInSeconds >= 60 * 5) {
      return "#727370";
    }

    const colorMap = {
      OPERATIVE: "#28a745",
      SLEEP: "#0066ff",
      NIGHT_SCAN: "#26c4f6",
      MAINTENANCE: "#ff7b25",
      LOCKERS_FULL: "#ff0000",
      TICKET_EMPTY: "#ff0000",
      OPERATIVE_SLEEP: "#28a745",
      MAINTENANCE_SLEEP: "#ff7b25",
      KERONG_OTA: "#000000",
      BOOTLOADER_OTA: "#000000",
      BLE_OFF: "#288BA8",
      "FULL QR": "#800080",
    };

    return colorMap[status] || "#727370";
  }

  async componentDidMount() {
    const { fullname, fetchMachinesNightscan } = this.props;

    if (fullname === "Joaquin Abellan") {
      this.logout();
    }

    fetchMachinesNightscan();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.machinesNightscan !== this.props.machinesNightscan) {
      const excludedSerials = [
        "SHOWROOM-I",
        "SHOWROOM-O",
        "VLK00000",
        "VLK00001",
      ];

      const issues = (this.props.machinesNightscan || []).filter((machine) => {
        const date = this.formatNightscanDate(machine.NightScanTimeStampEnd);
        const isNotInSleepPeriod = !this.isNightscanInSleepPeriod(
          date,
          machine.SleepStart,
          machine.SleepEnd
        );
        const isNotExcludedSerial = !excludedSerials.includes(machine.Serial);

        return isNotInSleepPeriod && isNotExcludedSerial;
      });

      this.setState({ nightscanIssues: issues });
    }
  }

  render() {
    const { role, type, fullname, id, category } = this.props;

    return (
      <Navbar className="box-shadow bg-vw-dark" dark expand="md">
        <Container>
          <NavbarBrand tag={Link} to="/">
            <img className="logo" src="/images/logo.svg" alt="Logo" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto align-items-center" navbar>
              {((role === "ADMIN" && type === "MASTER") ||
                (role === "CUSTOMER" &&
                  (category === "MONTARTO"))) && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/hotelrental"
                    onClick={() => this.handleNavLinkClick()}
                  >
                    <button className="btn btn-success">
                      <i className="fas fa-hotel mr-1"></i>MONTARTO
                    </button>
                  </NavLink>
                </NavItem>
              )}
              {role === "CUSTOMER" &&
                category !== "MONTARTO" &&
                type === "PDA" && (
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/lockersale"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <button className="btn btn-primary">
                        <i className="fas fa-credit-card mr-1"></i>VENDER
                      </button>
                    </NavLink>
                  </NavItem>
                )}
              {((role === "ADMIN" && type === "MASTER") ||
                role === "CUSTOMER") && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/pin"
                    onClick={() => this.handleNavLinkClick()}
                  >
                    <button className="btn btn-warning">
                      <i className="fas fa-unlock-alt mr-1"></i>RECUPERAR
                    </button>
                  </NavLink>
                </NavItem>
              )}
              {role === "CUSTOMER" && (
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/supportticketadd"
                    onClick={() => this.handleNavLinkClick()}
                  >
                    <button className="btn btn-secondary">
                      <i className="fas fa-receipt mr-1"></i>TICKET
                    </button>
                  </NavLink>
                </NavItem>
              )}
              {((role === "ADMIN" &&
                type !== "PRODUCCION" &&
                type !== "CASH") ||
                role === "CUSTOMER") && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    CANALES DE VENTA
                  </DropdownToggle>
                  <DropdownMenu className="custom-submenu">
                    <DropdownItem
                      tag={Link}
                      to="/machines"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-desktop mr-1"></i>
                      {category === "BAQUEIRA" ? "CONTROLADORES" : "KIOSCOS"}
                    </DropdownItem>
                    {role === "ADMIN" && type !== "CASH" && (
                      <DropdownItem
                        tag={Link}
                        to="/qrs"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-qrcode mr-1"></i>QRS
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type !== "CASH" && (
                      <DropdownItem
                        tag={Link}
                        to="/pdas"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-mobile mr-1"></i>PDAS
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" && type !== "PRODUCCION") ||
                      (role === "CUSTOMER" &&
                        category === "BAQUEIRA" &&
                        type !== "PDA")) && (
                      <DropdownItem
                        tag={Link}
                        to="/operators"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-map-signs mr-1"></i>AGREGADORES
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              {((role === "ADMIN" && type !== "CASH") ||
                (role === "CUSTOMER")) && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    OPERATIVA
                  </DropdownToggle>
                  <DropdownMenu className="custom-submenu">
                    {role === "ADMIN" &&
                      type !== "PRODUCCION" &&
                      type !== "LIMITED" && (
                        <DropdownItem
                          tag={Link}
                          to="/supporttickets"
                          onClick={() => this.handleNavLinkClick()}
                        >
                          <i className="fas fa-receipt mr-1"></i>TICKETS
                        </DropdownItem>
                      )}
                    {role === "ADMIN" && type !== "PRODUCCION" && (
                      <DropdownItem
                        tag={Link}
                        to="/faults"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-info mr-1"></i>AVERIAS
                      </DropdownItem>
                    )}
                    {role === "ADMIN" &&
                      type !== "PRODUCCION" &&
                      type !== "LIMITED" && (
                        <DropdownItem
                          tag={Link}
                          to="/incidences"
                          onClick={() => this.handleNavLinkClick()}
                        >
                          <i className="fas fa-exclamation-triangle mr-1"></i>
                          INCIDENCIAS
                        </DropdownItem>
                      )}
                    {role === "ADMIN" && type !== "PRODUCCION" && (
                      <DropdownItem
                        tag={Link}
                        to="/audit"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-database mr-1"></i>AUDIT
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type !== "PRODUCCION" && (
                      <DropdownItem
                        tag={Link}
                        to="/tpvs"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-mobile mr-1"></i>TPVs
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && (
                      <DropdownItem
                        tag={Link}
                        to="/modules"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-th mr-1"></i>MÓDULOS
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type === "MASTER" && (
                      <DropdownItem
                        tag={Link}
                        to="/matrixs"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-cubes mr-1"></i>VERSIONES
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type === "MASTER" && (
                      <DropdownItem
                        tag={Link}
                        to="/lowbluetooth"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-wifi mr-1"></i>BLUETOOTH
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type !== "PRODUCCION" && (
                      <DropdownItem
                        tag={Link}
                        to="/lockersqty"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-arrow-up-wide-short mr-1"></i>
                        LOCKERS QTY
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type === "MASTER" && (
                      <DropdownItem
                        tag={Link}
                        to="/openings"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-door-open mr-1"></i>APERTURAS
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type !== "PRODUCCION" && (
                      <DropdownItem
                        tag={Link}
                        to="/pinrecovers"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-lock mr-1"></i>RECUPERACIÓN PINES
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" && type !== "PRODUCCION") ||
                      (role === "CUSTOMER")) && (
                      <DropdownItem
                        tag={Link}
                        to="/rentals"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-key mr-1"></i>RESERVAS
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" &&
                      type !== "PRODUCCION" &&
                      type !== "LIMITED") ||
                      (role === "CUSTOMER" &&
                        type !== "PDA" && category !== "MONTARTO")) && (
                      <DropdownItem
                        tag={Link}
                        to="/calendars"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-calendar mr-1"></i>CALENDARIOS
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" &&
                      type !== "PRODUCCION" &&
                      type !== "LIMITED") ||
                      (role === "CUSTOMER" &&
                        category === "BAQUEIRA" &&
                        type !== "PDA")) && (
                      <DropdownItem
                        tag={Link}
                        to="/rules"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-pencil-ruler mr-1"></i>REGLAS DE
                        NEGOCIO
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" &&
                      type !== "PRODUCCION" &&
                      type !== "LIMITED") ||
                      (role === "CUSTOMER" &&
                        category === "BAQUEIRA" &&
                        type !== "PDA")) && (
                      <DropdownItem
                        tag={Link}
                        to="/articles"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-sitemap mr-1"></i>ARTÍCULOS
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" &&
                      type !== "PRODUCCION" &&
                      type !== "LIMITED") ||
                      (role === "CUSTOMER" &&
                        category === "BAQUEIRA" &&
                        type !== "PDA")) && (
                      <DropdownItem
                        tag={Link}
                        to="/arqueosbaqueira"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-gem mr-1"></i>ARQUEOS ERP BAQUEIRA
                      </DropdownItem>
                    )}
                    {/* {type !== 'PRODUCCION' &&
                      <DropdownItem tag={Link} to="/universalupdates" onClick={() => this.handleNavLinkClick()}>
                        <i className="fas fa-download mr-1"></i>ACTUALIZACIONES
                      </DropdownItem>
                    } */}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              {((role === "ADMIN" &&
                type !== "PRODUCCION" &&
                type !== "LIMITED") ||
                (role === "CUSTOMER" && type !== "PDA" && category !== "MONTARTO")) && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    VENTAS
                  </DropdownToggle>
                  <DropdownMenu className="custom-submenu">
                    <DropdownItem
                      tag={Link}
                      to="/sales"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-filter mr-1"></i>ANÁLISIS
                    </DropdownItem>
                    {role === "ADMIN" && (
                      <DropdownItem
                        tag={Link}
                        to="/internalsales"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-star mr-1"></i>ANÁLISIS POR TIPO
                      </DropdownItem>
                    )}
                    {(role === "ADMIN" ||
                      (role === "CUSTOMER" && type === "GROUP")) && (
                      <DropdownItem
                        tag={Link}
                        to="/arqueos"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-chart-bar mr-1"></i>GRÁFICOS
                      </DropdownItem>
                    )}
                    {(role === "ADMIN" ||
                      (role === "CUSTOMER" && type === "GROUP")) && (
                      <DropdownItem tag={Link} to="/arqueossales">
                        <i class="fas fa-chart-pie mr-1"></i>KPI
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" && type !== "CASH") ||
                      (role === "CUSTOMER" && category !== "BAQUEIRA")) && (
                      <DropdownItem
                        tag={Link}
                        to="/withdrawals"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-calculator mr-1"></i>RETIROS
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" && type !== "CASH") ||
                      (role === "CUSTOMER" && type === "GROUP")) && (
                      <DropdownItem
                        tag={Link}
                        to="/ocupation"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-chart-bar mr-1"></i>OCUPACIÓN
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" && type !== "CASH") ||
                      (role === "CUSTOMER" &&
                        category == "BAQUEIRA" &&
                        type !== "PDA")) && (
                      <DropdownItem
                        tag={Link}
                        to="/ocupationaccumulated"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-chart-bar mr-1"></i>OCUPACIÓN ACUMULADA
                      </DropdownItem>
                    )}
                    {((role === "ADMIN" && type !== "CASH") ||
                      (role === "CUSTOMER" &&
                        category == "BAQUEIRA" &&
                        type !== "PDA")) && (
                      <DropdownItem
                        tag={Link}
                        to="/ocupationdaily"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-chart-bar mr-1"></i>OCUPACIÓN DIARIA
                      </DropdownItem>
                    )}
                    {role === "ADMIN" && type !== "CASH" && (
                      <DropdownItem
                        tag={Link}
                        to="/objectives"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i class="fas fa-bullseye mr-1"></i>OBJETIVOS
                      </DropdownItem>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              {(role === "ADMIN" ||
                (role === "CUSTOMER" && category !== "BAQUEIRA")) && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    SOPORTE
                  </DropdownToggle>
                  <DropdownMenu className="custom-submenu">
                    <DropdownItem
                      tag={Link}
                      to="/faqs"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-question mr-1"></i>FAQs
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to="/manuals"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-book mr-1"></i>MANUALES
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              {role === "ADMIN" && type !== "PRODUCCION" && type !== "CASH" && (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    ADMINISTRACIÓN
                  </DropdownToggle>
                  <DropdownMenu className="custom-submenu">
                    <DropdownItem
                      tag={Link}
                      to="/customers"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-crown mr-1"></i>CLIENTES
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to="/contracts"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-file-signature mr-1"></i>CONTRATOS
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to="/promoters"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-users mr-1"></i>PROMOTORES
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}                      to="/discount-codes"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-tags mr-1"></i>CÓDIGOS DESCUENTO
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}                      to="/email-templates"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-envelope mr-1"></i>PLANTILLAS EMAIL
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to="/partners"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-handshake mr-1"></i>PARTNERS
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to="/gameranking"
                      onClick={() => this.handleNavLinkClick()}
                    >
                      <i className="fas fa-gamepad mr-1"></i>JUEGOS
                    </DropdownItem>
                    {type !== "LIMITED" && (
                      <DropdownItem
                        tag={Link}
                        to="/replacements"
                        onClick={() => this.handleNavLinkClick()}
                      >
                        <i className="fas fa-bars mr-1"></i>RECAMBIOS
                      </DropdownItem>
                    )}
                    {type === "MASTER" && (
                      <div>
                        <DropdownItem divider />
                        <DropdownItem
                          tag={Link}
                          to="/users"
                          onClick={() => this.handleNavLinkClick()}
                        >
                          <i className="fas fa-user-secret mr-1"></i>
                          ADMINISTRADORES
                        </DropdownItem>
                      </div>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
              <NavItem className="d-flex align-items-center">
                <GoogleTranslate />
              </NavItem>
              <button type="button" className="btn btn-outline-light mr-2">
                <span
                  style={{ paddingRight: "20px", paddingLeft: "20px" }}
                  onClick={this.showDragonGif}
                >
                  <i className="fas fa-user mr-1"></i>
                  {fullname}
                </span>
              </button>
              <button className="btn btn-outline-light" onClick={this.logout}>
                <i className="fas fa-sign-out-alt mr-1"></i>
                SALIR
              </button>
              {/*TONTUNA*/}
              {this.state.showDragon && (
                <img
                  className="dragon-gif"
                  src="/images/dump/pulp.gif"
                  alt="Dragon GIF"
                />
              )}
              {this.state.showFutbol && (
                <img
                  className="dragon-gif"
                  src="/images/dump/madrid.gif"
                  alt="Futbol GIF"
                />
              )}
              {this.state.showDuck && (
                <img
                  className="dragon-gif"
                  src="/images/dump/yisus.gif"
                  alt="Yisus GIF"
                />
              )}
              {this.state.showCuba && (
                <img
                  className="dragon-gif"
                  src="/images/dump/cuba.gif"
                  alt="Cuba GIF"
                />
              )}
              {this.state.showCrocs && (
                <img
                  className="dragon-gif"
                  src="/images/dump/crocs.gif"
                  alt="Crocs GIF"
                />
              )}
            </Nav>
          </Collapse>
        </Container>
        {role === "ADMIN" && (
          <div className="floating-nightscan-container">
            <button
              className="floating-nightscan-button"
              onClick={this.toggleNightscanList}
            >
              <div style={{ position: "relative" }}>
                <i className="fas fa-info"></i>
                <span
                  className="badge badge-danger"
                  style={{
                    position: "absolute",
                    top: "-25px",
                    left: "-25px",
                    fontSize: "0.75rem",
                    borderRadius: "50%",
                    width: "25px",
                    height: "25px",
                    lineHeight: "20px",
                  }}
                >
                  {this.state.nightscanIssues.length}
                </span>
              </div>
            </button>

            {this.state.showNightscanList && (
              <div className="nightscan-popup bg-light border rounded p-2 position-absolute">
                <h6>Incidencias Nightscan</h6>
                <ul
                  className="list-unstyled m-0"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  {this.state.nightscanIssues.map((machine) => {
                    const date = this.formatNightscanDate(
                      machine.NightScanTimeStampEnd
                    ).toLocaleString();
                    return (
                      <li key={machine._id} className="mb-2">
                        <button
                          className="btn btn-sm btn-outline-dark w-100 text-left"
                          onClick={() => this.goTo(machine._id)}
                        >
                          <strong>{machine.Serial}</strong> -
                          {
                            <div
                              className="badge"
                              style={{
                                backgroundColor: this.getMachineStatusColor(
                                  machine.Status,
                                  machine.Last_signal
                                ),
                              }}
                            >
                              {this.getMachineStatus(
                                machine.Status,
                                machine.Last_signal
                              )}
                            </div>
                          }
                          <br />
                          <small>Client: {machine.Customer.Fullname}</small>
                          <br />
                          <small>Night: {date}</small>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        )}

        <FloatingToolsButton />
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  category: state.auth.category,
  machinesNightscan: state.machines.machinesNightscan,
});

const mapDispatchToProps = (dispatch) => ({
  authLogout: bindActionCreators(authLogout, dispatch),
  fetchMachinesNightscan: bindActionCreators(fetchMachinesNightscan, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
